import { reactive } from 'vue';
import { getIsLyricShow } from '../../../utils/utils';

function createImage(src = '') {
  const img = new Image();
  img.src = src;
  return img;
}
export const DragType = {
  file: 'file',
  folder: 'folder',
};
export const dragImage = {
  grid: {
    // eslint-disable-next-line global-require
    src: createImage(require('../imgs/drag_grid.png')),
    w: 80,
    h: 80,
  },
  flow: {
    // eslint-disable-next-line global-require
    src: createImage(require('../imgs/drag_flow.png')),
    w: 40,
    h: 40,
  },
};
export default function handleDrag(props, emit) {
  function checkHasCouple(dataSource) {
    if (getIsLyricShow(dataSource.type)) {
      return true;
    }
    return Number(dataSource.lrcStatus) === 1;
  }

  function getDragItem(propsData) {
    return {
      key: propsData.articleKey,
      type: propsData.type,
      title: propsData.title,
    };
  }
  const dargData = reactive({
    articleKeyList: [],
    columnKeyList: [],
    isChecked: false, // 是否是拖拽的已选择的数据
    hasDeepColumn: false, // 是否有选择含非单级文件夹
    hasCouple: checkHasCouple(props.dataSource), // 是否有对应的irc或者audio数据（展示弹框用）
    columnKey: props.columnKey,
  });
  function makeDargFileData(checkFileList) {
    dargData.hasCouple = false;
    dargData.articleKeyList = checkFileList.map(item => {
      if (checkHasCouple(item)) {
        dargData.hasCouple = true;
      }
      return getDragItem(item);
    });
  }
  function makeDargFolderData(folderList) {
    dargData.hasDeepColumn = false;
    dargData.columnKeyList = folderList.map(folder => {
      if (+folder.containColumnNum) {
        dargData.hasDeepColumn = true;
      }
      return { key: folder.columnKey };
    });
  }
  function makeDargData(dragType, list) {
    if (dragType === DragType.file) {
      makeDargFileData(list);
      return;
    }
    makeDargFolderData(list);
  }

  function checkIsChoose(dragType) {
    const { checkFileList, checkIrcList, dataSource, checkFolderList } = props;
    if (dragType === DragType.file) {
      // 当前拖动的文件夹是否已勾选
      return !![...checkFileList, ...checkIrcList].find(
        item => item.articleKey === dataSource.articleKey && item.type === dataSource.type
      );
    }
    // 当前拖动的文件是否已勾选
    return !!checkFolderList.find(item => item.columnKey === dataSource.columnKey);
  }
  function getDargDataSource(dragType) {
    const { checkFileList, checkIrcList, dataSource, checkFolderList } = props;
    const checkList = [...checkFileList, ...checkIrcList];
    const isChoose = checkIsChoose(dragType);
    // 当前拖动的文件（或文件夹）已勾选，就拖动所有勾选的，否则清空勾选内容拖动当前文件（或文件夹）
    if (isChoose) {
      makeDargFolderData([...checkFolderList]);
      makeDargFileData([...checkList]);
    } else {
      emit('initChoose');
      makeDargData(dragType, [dataSource]);
    }
    console.log('zxx--dargData--', dargData, props, isChoose, dragType);
    return dargData;
  }

  return {
    dragstart: getDargDataSource,
    dragDataSource: dargData,
  };
}
